import { testResultSchema } from '../testResultSchema'

// 分類定数・フォーム表示用スキーマのみここに置く。OCR専用のプロンプト・OCR出力スキーマは
// @mbscan/backend-ocr（packages/backend/ocr/src/categories/document/schemas/todaFresh.ts）が正本。

export const todaFreshDocumentNameText = 'フレッシュコンクリート試験結果_日東コンクリート'
export const todaFreshDocumentType = 'フレッシュコンクリート試験結果'
export const todaFreshInspectionCompanyName = '日東コンクリート'
export const todaFreshGeneralContractorName = '戸田建設'

// 「基本情報」セレクト（帳票種別・検査会社名）の選択結果が
// この帳票に一致した時に、Modal 上で表示すべき TestResult のフィールド集合。
// transform で undefined を入れているもの（打設番号 / CON数量_m3 / 先送りモルタル_m3 / 圧縮強度試験）は除外。
export const todaFreshFormFieldsSchema = testResultSchema.pick({
  打設日: true,
  打設箇所: true,
  Fc_N_per_mm2: true,
  Fq_N_per_mm2: true,
  種類: true,
  呼び強度: true,
  スランプ_cm: true,
  骨材寸法_mm: true,
  セメント: true,
  プラント名: true,
  受入検査結果: true,
  天気: true,
  使用測定器: true,
  判定基準強度: true,
})
